import {BaseHttpProvider} from './base';
import {DataProcessingProtocol} from '../processor';
import {Observable} from 'rxjs';
import {HttpClient, HttpParams} from "@angular/common/http";
import { take } from 'rxjs/operators';

export abstract class GetProvider<T> extends BaseHttpProvider<T> {
  constructor(public http: HttpClient) {
    super();
  }

  /**
   * Generate a get observable and
   */
  protected generateBaseObservable(
    urlSearchParams?: HttpParams): Observable<any> {
    var token = this.authProtocol != null && this.authProtocol != undefined ? this.authProtocol.getToken() : null;
    var get;
    var userToken;
    if (token instanceof Observable) {
      token.pipe(take(1)).subscribe(user => {
        if (user != null)
          userToken = user.token;
        else
          userToken = null;
        get = this.http.get(
          this.endpoint,
          {
            headers: this.getHeaders(userToken),
            params: urlSearchParams
          });
      })
    } else {
      get = this.http.get(
        this.endpoint,
        {
          headers: this.getHeaders(token),
          params: urlSearchParams
        });
    }
    return get;
  }
}


export abstract class BaseGetProvider<T>
  extends GetProvider<T>
  implements DataProcessingProtocol {

  constructor(public http: HttpClient) {
    super(http);
    this.processingDelegate = this;
  }

  processResponse(response: any) {
    if (!(response instanceof Array))
      response = [response]

    var datas = [];
    for (var data of response) {
      var modelObj = new this.model().deserialize(data);
      datas.push(modelObj);
    }

    return datas
  }
}


export abstract class BaseEavGetProvider<T>
  extends GetProvider<T>
  implements DataProcessingProtocol {

  constructor(public http: HttpClient) {
    super(http);
    this.processingDelegate = this;
  }

  processResponse(response: any) {
    let data = this.model.eavDeserialize(response.attribute);
    return data;
    // this.model.eavDeserialize(response.attribute);
  }
}
